import { getBlogPost, getMenuData } from "api";
import { GetServerSideProps } from "next";
import { getCanonicalUrlFromContext } from "utils/formatters";
import { getCommonOgData, getPageDescription } from "utils/seoFormatters";
import { BlogPostPage } from 'containers/BlogPage/BlogPostPage';

export const getServerSideProps: GetServerSideProps = async (context) => {
  const slug = context.params?.slug;
  const force = !!context.query.force;

  const blogPostRequest = getBlogPost(slug as string);
  const menuDataRequest = getMenuData(force);

  const [menuData, blogPost] = await Promise.all([menuDataRequest, blogPostRequest]);

  return {
    props: {
      menuData,
      blogPost: blogPost.data,
      relatedPosts: blogPost.related_posts || [],
      ogData: getCommonOgData({
        url: getCanonicalUrlFromContext(context),
        title: blogPost.data?.title,
        banner: blogPost.data?.image || '/brands/brands-banner.png',
        description: getPageDescription('blogPost', { title: blogPost.data?.title, subtitle: blogPost.data?.subtitle }),
      }),
    },
  };
};

export default BlogPostPage;
